<script>
import UserResource from '../resources/user'
import messages from '../mixins/messages'
import LoginForm from '../components/LoginForm.vue'

export default {
    name: 'SignupDeveloper',
    mixins: [messages],
    components: {
        LoginForm
    },
    data() {
        return {
            loading: false,
            hasAccount: false,
            accountFormState: {},
            accountModel: {
                firstName: '',
                lastName: '',
                email: '',
            },
        }
    },
    watch: {
        
    },
    methods: {
        async onSubmit() {
            if(this.accountFormState.$valid) {
                try {
                    this.loading = true

                    let user = new UserResource({
                        username: this.accountModel.email,
                        email: this.accountModel.email,
                        password: this.accountModel.password,
                        first_name: this.accountModel.firstName,
                        last_name: this.accountModel.lastName
                    })
                    
                    await user.save()

                    await this.$store.dispatch('login', {
                        username: user.get('email'),
                        password: this.accountModel.password,
                    })

                    this.successRedirect()
                } catch(e) {
                    this.addError(this.parseAPIErrorsOrRethrow(e))
                } finally {
                    this.loading = false
                }
            }
        },
        successRedirect() {
            this.$router.push({ name: 'signupDeveloperProfile'})
        }
    },
    async mounted() {
        let userResource = this.$store.getters.userResource
        
        if(userResource) {
            this.successRedirect()
        }
    },
}
</script>

<template>
    <div v-page-title="'Create a Developer Profile'">
        <section>
            <div class="section-heading text-center mb-0 mt-5">
                <p>Find Your Ideal Next Role</p>
                <h2>Just a Few Steps Away...</h2>
            </div>
        </section>

        <section class="p-md-5 mt-5 gray">
            <b-container>
                <b-row>
                    <b-col sm="6" md="4">
                        <b-card v-if="!hasAccount">
                            <vue-form :state="accountFormState" @submit.prevent="onSubmit">
                                <b-row>
                                    <b-col md="6">
                                        <validate auto-label>
                                            <b-form-group label="First Name">
                                                <b-form-input name="firstName" v-model="accountModel.firstName" required />
                                                <field-messages name="firstName" show="$submitted">
                                                    <small slot="required" class="text-danger">Required</small>
                                                </field-messages>
                                            </b-form-group>
                                        </validate>
                                    </b-col>
                                    <b-col md="6">
                                        <validate auto-label>
                                            <b-form-group label="Last Name">
                                                <b-form-input name="lastName" v-model="accountModel.lastName" required />
                                                <field-messages name="lastName" show="$submitted">
                                                    <small slot="required" class="text-danger">Required</small>
                                                </field-messages>
                                            </b-form-group>
                                        </validate>
                                    </b-col>
                                </b-row>

                                <validate auto-label>
                                    <b-form-group label="Email Address">
                                        <b-form-input type="email" name="email" v-model="accountModel.email" ref="emailInput" required />
                                        <field-messages name="email" show="$submitted">
                                            <small slot="required" class="text-danger">Email is required</small>
                                            <small slot="email" class="text-danger">Email is invalid</small>
                                            <small slot="email-exists" class="text-danger">Email already exists</small>
                                        </field-messages>
                                    </b-form-group>
                                </validate>

                                <validate auto-label>
                                    <b-form-group label="Password">
                                        <b-form-input type="password" name="password" v-model="accountModel.password" required />
                                        <field-messages name="password" show="$submitted">
                                            <small slot="required" class="text-danger">Password is required</small>
                                        </field-messages>
                                    </b-form-group>
                                </validate>

                                <messages :to="messages" />

                                <b-button type="submit" variant="primary" size="lg" :disabled="loading">Next</b-button>
                                
                                <small class="float-right">
                                    <b-button variant="link" size="sm" @click="hasAccount = true">Already Have an Account?</b-button>
                                </small>
                            </vue-form>
                        </b-card>
                        <b-card v-else>
                            <login-form @register="hasAccount = false" @success="successRedirect()" submit-text="Next"></login-form>
                        </b-card>
                    </b-col>

                    <b-col>

                        <b-row class="mb-3">
                            <b-col sm="1">
                                <p class="h1"><b-icon icon="award-fill" /></p>
                            </b-col>
                            <b-col>
                                <h4>See What Matters To You, Up Front</h4>
                                <p>Salary, equity, remote flexibility, and more, described in every job listing.</p>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col sm="1">
                                <p class="h1"><b-icon icon="lightning-fill" /></p>
                            </b-col>
                            <b-col>
                                <h4>Instant Applications</h4>
                                <p>Apply directly to jobs with a single application and a single profile.</p>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col sm="1">
                                <p class="h1"><b-icon icon="chat-text-fill" /></p>
                            </b-col>
                            <b-col>
                                <h4>No Recruiters</h4>
                                <p>Talk directly with the Founders, Investors, and Hiring Managers you'll be working with.</p>
                            </b-col>
                        </b-row>

                    </b-col>
                </b-row>
            </b-container>
        </section>
    </div>
</template>

<style lang="scss">

</style>
